import type { ComputedRef } from 'vue'

import { useDisciplineStore } from '@stores/discipline'

import { useKidRoutes } from '@composables/routes/kid-route.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface HeaderLogoReturn {
  homeUrl: ComputedRef<string>
  trackLogoClick: () => void
}

export const useHeaderLogo = (): HeaderLogoReturn => {
  const disciplineStore = useDisciplineStore()

  const {
    homeMath,
    homeEla,
  } = useKidRoutes()

  // A plain link: the app reloads on the active discipline's home, as the legacy logo buttons did.
  const homeUrl = computed(() => (disciplineStore.isEla ? homeEla.value : homeMath.value) || '/')

  const trackLogoClick = (): void => {
    trackEvent(amplitudeConfig.events.clickLink, {
      name: 'link_logo',
    })
  }

  return {
    homeUrl,
    trackLogoClick,
  }
}
